module.exports = __webpack_public_path__ + "img/level_s_gray.795cd20a.png";